import { makeAutoObservable, action, computed } from "mobx";

export default class OrgDashboardStore {
  status = {};
  pinned = {};
  alertLabel = {};
  introspection = {};
  heartRate = {};
  hrv = {};
  motion = {};
  counter = 0;

  // chart tracking
  currentTimestamp = null;
  mousePos = [0, 0];

  //admin
  adminMode = false;

  get isActive() {
    const active = {};
    Object.keys(this.heartRate).forEach((userCode) => {
      const heartRate = this.heartRate[userCode];
      if (!heartRate) {
        active[userCode] = false;
      } else {
        const date = new Date(heartRate.timestamp);
        const diff = new Date().getTime() - date.getTime();
        if (diff < 60 * 1000) {
          active[userCode] = true;
        } else {
          active[userCode] = false;
        }
      }
    });
    return active;
  }

  setStatus(userCode, status) {
    this.status[userCode] = status;
    this.counter += 1;
  }

  setAlertLabel(userCode, alertLabel) {
    this.alertLabel[userCode] = alertLabel;
    this.counter += 1;
  }

  setIntrospection(userCode, introspection) {
    this.introspection[userCode] = introspection;
    this.counter += 1;
  }

  setHeartRate(userCode, heartRate) {
    this.heartRate[userCode] = heartRate;
    this.counter += 1;
  }

  setHrv(userCode, hrv) {
    this.hrv[userCode] = hrv;
    this.counter += 1;
  }

  setMotion(userCode, motion) {
    this.motion[userCode] = motion;
    this.counter += 1;
  }

  setAdminMode(adminMode) {
    this.adminMode = adminMode;
  }

  setIsActive(userCode, value) {
    this.isActive[userCode] = value;
  }

  setPinned(userCode, status) {
    this.pinned[userCode] = status;
    this.counter += 1;
  }

  setCurrentTimestamp = (currentTimestamp) => {
    this.currentTimestamp = currentTimestamp;
  }

  setMousePos = (mousePos) => {
    this.mousePos = mousePos;
  }

  constructor() {
    makeAutoObservable(this, {
      isActive: computed,
      setAdminMode: action,
      setStatus: action,
      setHeartRate: action,
      setHrv: action,
      setMotion: action,
      setAlertLabel: action,
      setIntrospection: action,
      setIsActive: action,
      setPinned: action,
      setCurrentTimestamp: action,
      setMousePos: action
    });
  }
}
